import { Component, computed, input } from '@angular/core';
import { ClassValue } from 'clsx';
import { bui } from '../utils/bui';

@Component({
  selector: 'sidebar-spacer',
  exportAs: 'sidebarSpacer',
  host: {
    '[class]': 'computedClass()',
  },
  template: ``,
})
export class SidebarSpacer {
  // Inputs / Outputs
  readonly userClass = input<ClassValue>('', { alias: 'class' });

  // State
  protected readonly computedClass = computed(() =>
    bui(
      // Base
      'group/sidebar-spacer',
      'flex-auto',

      // User classes
      this.userClass(),
    ),
  );
}
